import React, { useState, useEffect, useMemo, useContext } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"
import { interpolateRgb } from "d3-interpolate";
import { color } from "d3-color";
import LiquidFillGauge from "react-liquid-gauge";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet';
import Select from "react-select";
import { Tooltip, Typography } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import DatagridComp from "../DatagridComp";
import { GetuserDatavalue } from "../../../Commonalert/commonalert";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import Loader from "../CommonLoader";
import { Container, Grid, Box } from '@mui/material';
import UserActivityTracker from "../../../hooks/userActivityTracker";
import WarningCount from "../Asset/esocardicon/SchemaDetail/WarningCount.svg";
import ErrorCount from "../Asset/esocardicon/SchemaDetail/ErrorCount.svg";
import Chart from "react-apexcharts";
import Commoncard from "../Commoncard";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import RunReportNow from "../RunReportNow";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import { Commonfun, timezonechange, timezoneval } from "../Commonfun";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import { AppContext } from "../../../Context/Context";
import { CheckCircle, Send } from "@mui/icons-material";
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";



export default function LinkBuilding() {

    const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
    const [cardData, setCardData] = useState([]);
    const [cardData1, setCardData1] = useState([]);
    const [loading, setLoading] = useState(false);
    const esodata = useSelector((state) => state);
    const ApiToken = esodata.apiauthkey.value;
    const [autoheightval, SetAutoheightval] = useState(true)
    const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
    const [apiopen, setapiOpen] = React.useState(false);
    const [apierrorMsg, setapierrorMsg] = useState();
    const [tableLoading, setTableLoading] = useState(true);
    const [tableLoading1, setTableLoading1] = useState(true);
    const [jobDate, setjobDate] = useState("");
    const [jobId, setjobId] = useState("");
    const [aiSuggestions, setAiSuggestions] = useState({});
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [selectedSuggesRow, setSelectedSuggesRow] = useState({
        suggesSid: null,
        suggesId: null,
        openModel: false
    });
    const [outReachData, setOutReachData] = useState({
        recipient: null,
        subject: null,
        body: null,
        openModel: false
    });
    const [suggesOption, setSuggesOption] = useState([]);
    const [selectedSugges, setSelectedSugges] = useState(null);
    const [recipientError, setRecipientError] = useState("");
    const [compId, setCompId] = useState("");
    const [prosId, setProsId] = useState("");
    const [refDomain, setRefDomain] = useState("");
    const [selectedTargetKeyword, setSelectedTargetKeyword] = useState('');
    const [faqData, setfaqData] = useState("2")
    const [toggle, setToggle] = useState(false);
    const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
    const navigate = useNavigate();
const [isBouncePopup, setIsBouncePopup] = useState(false);
    const [selectedBounceReason, setSelectedBounceReason] = useState("");
    const apihandleClose = () => {
        setapiOpen(false);
    };

    const handleAiReadinessClick = async () => {
        if (!ApiToken) {
            toast.error("Authorization token is missing or invalid. Please log in again.", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return;
        }

        setLoading(true);

        const data = {
            prospect_id: selectedSuggesRow.suggesId,
            user_domain_id: esodata.domaindata.value.header_selected,
            target_keyword: selectedTargetKeyword
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}backlinks/backlink_building_prospecting/`, data, {
                headers: {
                    Authorization: `${ApiToken}`,
                },
            });

            if (response?.status === 401) {
                toast.error("Session expired. Please log in again.", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/login"); // Redirect to login page
                return;
            }

            if (response?.data?.suggestions) {
                setAiSuggestions((prev) => ({
                    ...prev,
                    [selectedSuggesRow.suggesSid]: response.data.suggestions,
                }));
                closeSuggestion();
                toast.success("AI Suggestion loaded", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } else {
                toast.error("No suggestion found in response", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        } catch (error) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            console.error("Error fetching AI suggestion:", error);
        } finally {
            setLoading(false);
        }
    }

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };

    const handleOutReach = async () => {

        setLoading(true);

        // if(!validateEmail(outReachData.recipient)) {
        //     setRecipientError('Kindly enter valid email address');
        //     return;
        // }

        const data = {
            "user_domain_id": esodata.domaindata.value.header_selected,
            "job_id": jobId,
            "competitor_id": compId,
            "prospect_id": prosId,
            // "ref_domain": refDomain,
            "email": outReachData.recipient,
            "subject": outReachData.subject,
            "content": outReachData.body
        }

        if (selectedSugges) {
            data['chosen_anchor'] = selectedSugges.value;
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}backlinks/backlink_building_send_outreach/`, data, {
                headers: {
                    Authorization: `${ApiToken}`,
                },
            });

            if (response?.status === 401) {
                toast.error("Session expired. Please log in again.", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/login"); // Redirect to login page
                return;
            }

            if (response?.status === 200) {
                outReachPopup();
                LoadData();
                toast.success("Successfully Contacted!", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        } catch (error) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            console.error("Error fetching AI suggestion:", error);
        } finally {
            setLoading(false);
        }
    }

    const openSuggestion = (sid, id) => {
        setSelectedSuggesRow({
            suggesSid: sid,
            suggesId: id,
            openModel: true
        });
    }

    const closeSuggestion = () => {
        setSelectedSuggesRow({
            suggesSid: selectedSuggesRow.suggesSid,
            suggesId: selectedSuggesRow.suggesId,
            openModel: false
        });
        setSelectedTargetKeyword('');
    }

    const columns = [

        {
            field: "refdomain",
            headerName: "Ref Domain",
            minWidth: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            description: "The website that currently links to your competitors but does not link to you"
        },
        {
            field: "domain_inlink_rank",
            headerName: "Inlink Rank",
            minWidth: 100,
            flex: 1,
            disableClickEventBubbling: true,
            headerAlign: "center",
            align: "center",
            description: "How many of your selected competitors this domain links to. High match count means the domain is more likely to link to you.",
        },
        {
            field: "match_count",
            headerName: "Match Count",
            minWidth: 100,
            flex: 1,
            disableClickEventBubbling: true,
            headerAlign: "center",
            align: "center",
            description: "Match Count"
        },
        {
            field: "strategy",
            headerName: "Strategy",
            minWidth: 200,
            flex: 1,
            disableClickEventBubbling: true,
            headerAlign: "center",
            align: "center",
            description: "The suggested outreach method (e.g., Guest Post, Resource Page) based on the prospect's page content."
        },
        {
            field: "suggested_anchors",
            headerName: "AI Suggestion",
            description: "SEO-optimized anchor text ideas generated by AI to improve your ranking for target keywords.",
            minWidth: 300,
            flex: 1,
            headerAlign: "center",
            align: "center",
            disableClickEventBubbling: true,
            renderCell: (params) => {
                const rowId = params.row.sid;
                const suggestion = aiSuggestions[`${rowId}`];
                if (params?.row?.suggested_anchors.length > 0 || suggestion) {
                    return (
                        <ul style={{ textAlign: 'left' }}>
                            {(suggestion ?? params?.row?.suggested_anchors).map(item => {
                                return <li>{item}</li>
                            })}
                        </ul>
                    );
                }

                return (
                    <button
                        // onClick={() => handleAiReadinessClick(`${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_report/`, data, rowId)}
                        onClick={() => openSuggestion(params.row.sid, params.row.id)}
                        style={{
                            padding: "8px 16px",
                            backgroundColor: "#ff601f",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "500"
                        }}
                    >
                        Suggestion
                    </button>
                );
            }
        },
        // {
        //     field: "is_contacted",
        //     headerName: "Contacted",
        //     minWidth: 200,
        //     flex: 1,
        //     headerAlign: 'center',
        //     align: 'center',
        //     sortable: false,
        //     description: 'Contacted.',
        //     renderCell: (params) => {
        //         const isContacted = params.row.is_contacted;
        //         return (
        //             <div style={{
        //                 background: isContacted ? '#e5ffde' : "#e7e7e7",
        //                 padding: "10px",
        //                 borderRadius: "10px",
        //                 color: isContacted ? '#227d0b' : "#000",
        //             }} >
        //                 <div>{isContacted ? 'Contacted' : 'Not Contacted'}</div>
        //             </div >
        //         );
        //     }
        // },
{
            field: "action",
            headerName: "Out Reach",
            description: "Click the mail icon to open the email composer. From there, you can edit, select an anchor, and send your pitch",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
            renderCell: (params) => {
                const outreachStatus = params.row.outreach_status; 
                const bounceReason = params.row.bounce_reason;     

                // Case 1: Successfully Sent
                if (outreachStatus === "sent") {
                    return (
                        <button
                            className="view-report-button"
                            style={{
                                background: '#e2ffe8',
                                padding: "10px",
                                borderRadius: "10px",
                                color: '#0c6810',
                                border: "none",
                                display: "flex",
                                alignItems: "center"
                            }}
                            disabled
                        >
                            <CheckCircle style={{ marginRight: '5px' }} />
                            Sent
                        </button>
                    );
                }

                // Case 2: Bounced (Button + View Reason Button matching Audit CSS)
                if (outreachStatus === "bounced") {
                    return (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px", padding: "10px 0" }}>
                            <button
                                onClick={() => {
                                    getCompSuggestion(params.row.id, params.row.refdomain);
                                    fetchOutReachData(params.row.competitor_id, params.row.refdomain, params.row.id); 
                                }}
                                style={{
                                    padding: "8px 16px",
                                    backgroundColor: "#d32f2f", 
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                            >
                                <Send style={{ marginRight: '5px' }} />
                                Bounced (Retry)
                            </button>
                            
                            <button 
                                className="view-report-button" 
                                onClick={() => { 
                                    setSelectedBounceReason(bounceReason); 
                                    setIsBouncePopup(true); 
                                }}
                                style={{ fontSize: '11px', padding: '4px 10px' }}
                            >
                                View Reason
                            </button>
                        </div>
                    );
                }

                // Case 3: Default (Not Contacted)
                return (
                    <button
                        onClick={() => {
                            getCompSuggestion(params.row.id, params.row.refdomain);
                            fetchOutReachData(params.row.competitor_id, params.row.refdomain, params.row.id);
                        }}
                        style={{
                            padding: "8px 16px",
                            backgroundColor: "#ff601f",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "500",
                            display: "flex",
                            alignItems: "center"
                        }}
                    >
                        <Send style={{ marginRight: '5px' }} />
                        Out Reach
                    </button>
                );
            }
        },
    ];

    const columns1 = [
        {
            field: "url_from",
            headerName: "URL From",
            description: "URL of the web page.",
            minWidth: 320,
            flex: 1,
            disableClickEventBubbling: true,
            headerAlign: "center",
            align: "center",
            renderCell: (cardData) => {
                let baseUrl =
                    cardData.row.url_from.split("/").slice(0, 3).join("/") + "/";
                let remaining = cardData.row.url_from.split("/").slice(3).join("/");
                return (
                    <>
                        <Tooltip title={cardData.row.url_from}>
                            <div className="prefered_url_external02">
                                <a
                                    target="_blank"
                                    href={cardData?.row?.url_from}
                                    style={{ display: "flex", flexDirection: "column" }}
                                >
                                    <span className="spanlink">
                                        <LinkIcon /> {baseUrl}
                                    </span>
                                    <span
                                        className="spanlink"
                                        style={{
                                            color: "#044792",
                                            wordWrap: "break-word",
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        {remaining}
                                    </span>
                                </a>
                            </div>
                        </Tooltip>
                    </>
                );
            },
        },
        {
            field: "new_lost_date",
            headerName: "New Lost Date",
            minWidth: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            description: "The website that currently links to your competitors but does not link to you",
            renderCell: (params) => {
                return (
                    <div>{timezonechange(params.row.new_lost_date)}</div>
                );
            }
        },
        {
            field: "domain_inlink_rank",
            headerName: "domain Inlink Rank",
            minWidth: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            description: "The website that currently links to your competitors but does not link to you"
        },
        {
            field: "anchor",
            headerName: "Anchor",
            minWidth: 300,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            description: "The website that currently links to your competitors but does not link to you"
        },
        {
            field: "is_contacted",
            headerName: "Outreach Matched",
            minWidth: 200,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            description: 'Outreach Matched.',
            renderCell: (params) => {
                const isMatched = params.row.matched_to_outreach;
                return (
                    <div style={{
                        background: isMatched ? '#e5ffde' : "#e7e7e7",
                        padding: "10px",
                        borderRadius: "10px",
                        color: isMatched ? '#227d0b' : "#000",
                    }} >
                        <div>{isMatched ? <CheckCircle style={{ marginRight: '5px' }} /> : 'Not Matched'}</div>
                    </div >
                );
            }
        },
{
            field: "status",
            headerName: "Email Status",
            description: "The delivery status of your email (Sent or Bounced)", 
            minWidth: 150,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const status = params.row.status; // "Sent", "Bounced", or "Delivered"
                const bounceReason = params.row.bounce_reason;

                if (status === "Bounced") {
                    return (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px", padding: "5px 0" }}>
                            <b style={{ color: "#d32f2f" }}>Bounced</b>
                            
                            {/* VIEW REASON BUTTON - MATCHES PROSPECTING STYLE */}
                            <button 
                                className="view-report-button" 
                                onClick={() => { 
                                    setSelectedBounceReason(bounceReason); 
                                    setIsBouncePopup(true); 
                                }}
                                style={{ fontSize: '11px', padding: '4px 10px' }}
                            >
                                View Reason
                            </button>
                        </div>
                    );
                }

                return (
                    <b style={{ color: status === "Sent" ? "#ff601f" : "#227d0b" }}>
                        {status || "Pending"}
                    </b>
                );
            }
        },
       
    ]

    const rows = cardData ?? [];
    const rows1 = cardData1 ?? [];
    const LoadData = async () => {
        setLoading(true);
        setTableLoading1(true);
        try {
            const datavalue = await axios.get(
                `${process.env.REACT_APP_API_URL}backlinks/backlink_building_prospecting/?user_domain_id=${esodata.domaindata.value.header_selected}`,
                {
                    headers: {
                        Authorization: `${ApiToken}`,
                    },
                }
            ).catch((error) => {
                if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                }
                else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                    navigate('/errorpages')
                }
            });
            if (datavalue?.data) {
                setjobDate(moment(datavalue.data.job_date).format("MMMM DD,YYYY HH:mm"));
                setjobId(datavalue.data.job_id)
            }

            if (datavalue?.data?.prospects) {
                var TableArray = [];
                TableArray = datavalue.data.prospects;

                if (TableArray && TableArray.length > 0) {
                    const newData = TableArray.map((obj, index) => {
                        return { ...obj, sid: index + 1 };
                    });
                    setCardData(newData);
                    SetAutoheightval(false)
                }
                else {
                    setCardData("");
                    SetAutoheightval(true)
                }
            }

        } catch (err) {
            console.log(err)
        }
        setTableLoading1(false);
        setLoading(false);
    }

    const linkTracker = async () => {
        setLoading(true);
        setTableLoading(true);
        try {
            const datavalue = await axios.get(
                `${process.env.REACT_APP_API_URL}backlinks/backlink_building_tracker/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobId}`,
                {
                    headers: {
                        Authorization: `${ApiToken}`,
                    },
                }
            ).catch((error) => {
                if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                }
                else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                    navigate('/errorpages')
                }
            });

            if (datavalue?.data?.acquired_links) {
                var TableArray = [];
                TableArray = datavalue.data.acquired_links;

                if (TableArray && TableArray.length > 0) {
                    const newData = TableArray.map((obj, index) => {
                        return { ...obj, sid: index + 1 };
                    });
                    setCardData1(newData);
                }
                else {
                    setCardData1("");
                }
            }

        } catch (err) {
            console.log(err)
        }
        setTableLoading(false);
        setLoading(false);
    }

    useEffect(() => {
        GetuserDatavalue(setOpenCommonAlerts, ApiToken, navigate);
        LoadData();
        linkTracker();
        faqdatafun();
    }, []);


    function openModal() {
        setIsOpen(true);
    }

    const handleModelPopUp = () => {
        openModal();
    }

    const handleDownlodingCSV = () => {
        csvdown();
    }

    const handleDownlodingPDF = () => {
        pdfdown();
    }

    const faqdatafun = async (menubutval = "") => {
        var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=93`
        try {
            const doaminsectiondatavalue = await axios.get(
                datavar,
                {
                    headers: {
                        Authorization: `${ApiToken}`,
                    },
                }
            );
            if (doaminsectiondatavalue?.data) {
                SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
            }
        } catch (err) { }
    }

    const pdfdown = async () => {

        setLoading(true);
        var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_summary/?user_domain_id=${esodata.domaindata.value.header_selected}&is_format=pdf&timezone=${timezoneval()}`;

        try {
            const response = await fetch(backdataurl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                    Authorization: `${ApiToken}`,
                },
            });
            if (response.ok) {
                const blob = await response.blob();

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                var filedata = await Commonfun('Link Building', "pdf", ApiToken, esodata.domaindata.value.header_selected);
                link.download = filedata;
                link.click();
                window.URL.revokeObjectURL(link.href);
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then(data => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error)
                    })
                }
                else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages')
                }
            }
        } catch (error) {
            toast.error("No Data", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            console.error('Error during PDF download:', error);
        }
        setLoading(false);
    }

    const csvdown = async () => {
        setLoading(true);
        var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_summary/?user_domain_id=${esodata.domaindata.value.header_selected}&is_format=csv&timezone=${timezoneval()}`;
        try {
            const response = await fetch(backdataurl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                    Authorization: `${ApiToken}`,
                },
            });
            if (response.ok) {
                const blob = await response.blob();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                var filedata = await Commonfun('Link Building', "csv", ApiToken, esodata.domaindata.value.header_selected);
                link.download = filedata;
                link.click();
                window.URL.revokeObjectURL(link.href);
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then(data => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error)
                    })
                }
                else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages')
                }
            }
        } catch (error) {
            toast.error("No Data", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            console.error('Error during PDF download:', error);
        }
        setLoading(false);

    }

    const handleToggle = () => {
        if (faqData != 1) {
            setfaqData(1)
        }
        else {
            setfaqData(2)
        }
        setToggle((pre) => !pre);
    };

    const outReachPopup = () => {
        setOutReachData({
            recipient: null,
            subject: null,
            body: null,
            openModel: false
        })
    }

    const getCompSuggestion = async (prospId = '', refeDomain = '') => {
        // setLoading(true);
        // setTableLoading(true);
        try {
            const datavalue = await axios.get(
                `${process.env.REACT_APP_API_URL}backlinks/ai_suggestion/?user_domain_id=${esodata.domaindata.value.header_selected}&prospect_id=${prospId}`,
                {
                    headers: {
                        Authorization: `${ApiToken}`,
                    },
                }
            ).catch((error) => {
                if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                }
                else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                    navigate('/errorpages')
                }
            });


            if (datavalue?.data) {
                const sugOptions = datavalue.data.suggestions.map(sug => {
                    return { label: sug, value: sug };
                });
                setRefDomain(refeDomain);
                setSuggesOption(sugOptions);
                setProsId(datavalue.data.prospect_id);
            }

        } catch (err) {
            console.log(err)
        }
        // setTableLoading(false);
        // setLoading(false);
    }

    const fetchOutReachData = async (compId = '', refeDomain = '', prospId = '') => {
        setLoading(true);
        setTableLoading1(true);
        setOutReachData({
            ...outReachData,
            openModel: true
        })
        setCompId(compId);
        try {
            const datavalue = await axios.get(
                `${process.env.REACT_APP_API_URL}backlinks/backlink_building_send_outreach/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobId}&competitor_id=${compId}&ref_domain=${refeDomain}&prospect_id=${prospId}`,
                {
                    headers: {
                        Authorization: `${ApiToken}`,
                    },
                }
            ).catch((error) => {
                if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                }
                else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                    navigate('/errorpages')
                }
            });


            if (datavalue?.data) {
                setOutReachData({
                    recipient: datavalue.data.email,
                    subject: datavalue.data.subject,
                    body: datavalue.data.content,
                    openModel: true
                })
            }

        } catch (err) {
            console.log(err)
        }
        setTableLoading1(false);
        setLoading(false);
    }

    return (
        <>
            <div className={`over_all_container search_prnt ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Backlink Building</title>
                </Helmet>
                {loading === true ? <Loader /> : null}
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />

                <Container maxWidth={false} className="dashboard-container">
                    <Box className="dashboard-box">
                        <Grid container className="dashboard-grid">
                            <Grid item xs={12} md={4}>
                                <div>
                                    <h1 className="dashboard_header">
                                        Backlink Building
                                        <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                                    </h1>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <div className="top_breadcrumb_menu">
                                    <div className="exportpdf_outer">
                                        <div className="breadcrumb-wrapper">
                                            <CommonBreadCrumb breadcrumbValue={[
                                                { title: 'Link Building' }
                                            ]} />
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="dashboard-container">
                    <Box className="dashboard-box-time">
                        <Grid container className="dashboard-grid">
                            <Grid item xs={12} md={6}>
                                <div className="time_zone">
                                    <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                                    <span className="timezone-val">{timezoneval()}</span>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="dashboard-container">
                    <Box className="grid_table_shodow">
                        <Grid container className="dashboard-grid">
                            <Grid item xs={12} md={12}>
                                <div className="cnt_audit_outer_wrap">
                                    <DatagridComp className="datagrid_custom_scroll"
                                        columns={columns}
                                        rows={rows}
                                        autoheightval={autoheightval}
                                        datagridval={2}
                                        columnFreezeWidth={[0]}
                                        tableLoading={tableLoading1}
                                        handleModelPopUp={handleModelPopUp}
                                        handleDownlodingCSV={handleDownlodingCSV}
                                        handleDownlodingPDF={handleDownlodingPDF}
                                        DownloadShowFile={false}
                                        customFilter={false}
                                        DownloadShowPDF={1}
                                        DownloadShowCSV={2}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="dashboard-container">
                    <h3 className="sub_heading_font">Link Tracker</h3>
                    <Box className="grid_table_shodow">
                        <Grid container className="dashboard-grid">
                            <Grid item xs={12} md={12}>
                                <div className="cnt_audit_outer_wrap">
                                    <DatagridComp className="datagrid_custom_scroll"
                                        columns={columns1}
                                        rows={rows1}
                                        autoheightval={autoheightval}
                                        datagridval={2}
                                        // columnFreezeWidth={[0]}
                                        tableLoading={tableLoading}
                                        handleModelPopUp={handleModelPopUp}
                                        handleDownlodingCSV={handleDownlodingCSV}
                                        handleDownlodingPDF={handleDownlodingPDF}
                                        DownloadShowFile={false}
                                        customFilter={false}
                                        DownloadShowPDF={1}
                                        DownloadShowCSV={2}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                {!openCommonAlerts &&
                    <CommonErrorAlert
                        data={{
                            apiopen: apiopen,
                            apiErrorMsg: apierrorMsg,
                            isIconStyled: true
                        }}
                        closeAlert={apihandleClose} />
                }

                <div className="">
                    <Dialog
                        open={selectedSuggesRow.openModel}
                        onClose={closeSuggestion}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        style={{ alignItems: 'flex-start' }}
                    >
                        <DialogTitle className="keyword-dialog-header">Get Suggestion</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description">
                                <div>
                                    <form className="frm_container">
                                        <div className="campaigns-addedit-row">
                                            <div className="keyword-col1-fields">
                                                <div>
                                                    <label for="city">
                                                        Target Keyword :
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="campaign-name"
                                                        value={selectedTargetKeyword}
                                                        onChange={(e) => { setSelectedTargetKeyword(e.target.value) }}
                                                        placeholder="Target Keyword"
                                                    />
                                                </div>
                                                <div>
                                                    <span className="error-value">{selectedTargetKeyword ? '' : 'This field is required'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions className="">
                            <div className="dialog-action-button">

                                <button className="keyword-submit" onClick={handleAiReadinessClick}>
                                    Submit
                                </button>
                                <button className="keyword-cancel" onClick={closeSuggestion}>
                                    Close
                                </button>

                            </div>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={outReachData.openModel}
                        onClose={outReachPopup}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        style={{ alignItems: 'flex-start' }}
                    >
                        <DialogTitle className="keyword-dialog-header">Send OutReact</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description">
                                <div>
                                    <form className="frm_container">
                                        <div className="keyword-col1-fields">
                                            <div>
                                                <label for="city">
                                                    Recipient :
                                                </label>
                                                <input
                                                    type="text"
                                                    className="campaign-name"
                                                    value={outReachData.recipient}
                                                    onChange={e => setOutReachData({ ...outReachData, recipient: e.target.value })}
                                                    placeholder="Recipient"
                                                />
                                            </div>
                                            <div className="error-value">{recipientError}</div>
                                        </div>
                                        <div className="keyword-col1-fields">
                                            <div>
                                                <label for="city">
                                                    Subject :
                                                </label>
                                                <input
                                                    type="text"
                                                    className="campaign-name"
                                                    value={outReachData.subject}
                                                    onChange={e => setOutReachData({ ...outReachData, subject: e.target.value })}
                                                    placeholder="Subject"
                                                />
                                            </div>
                                        </div>
                                        <div className="keyword-col1-fields">
                                            <label>Select Suggestion</label>
                                            <Select
                                                value={selectedSugges}
                                                options={suggesOption}
                                                placeholder="Select Suggestion..."
                                                isClearable
                                                onChange={(e) => setSelectedSugges(e)}
                                                styles={customDropdownStyles()}
                                                menuPortalTarget={document.body}
                                            />
                                        </div>
                                        <div className="keyword-col1-fields">
                                            <div>
                                                <label for="city">
                                                    Body :
                                                </label>
                                                <textarea
                                                    col={6}
                                                    // className="campaign-name"
                                                    style={{
                                                        height: "150px",
                                                        border: "1px solid #ff601f",
                                                        width: "100%",
                                                        padding: "0 0 0 17px",
                                                        borderRadius: "4px",
                                                    }}
                                                    value={outReachData.body}
                                                    onChange={e => setOutReachData({ ...outReachData, body: e.target.value })}
                                                    placeholder="Enter the Message.."
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions className="">
                            <div className="dialog-action-button">

                                <button className="keyword-submit" onClick={handleOutReach}>
                                    Submit
                                </button>
                                <button className="keyword-cancel" onClick={outReachPopup}>
                                    Close
                                </button>

                            </div>
                        </DialogActions>
                    </Dialog>
                     <Dialog
                    open={isBouncePopup}
                    onClose={() => setIsBouncePopup(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className="competitor_test_filter job_date_filter over_all_accessibility"
                >
                    <DialogTitle className="keyword-dialog-header">
                        {"Bounce Delivery Report"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            <div style={{ 
                                maxHeight: "300px", 
                                overflowY: "auto", 
                                padding: "15px", 
                                backgroundColor: "#fff5f5", 
                                borderRadius: "4px",
                                border: "1px solid #ffcccc",
                                color: "#d32f2f",
                                fontSize: "14px",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word"
                            }}>
                                {selectedBounceReason || "No technical details available for this bounce."}
                            </div>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="dialog-action-button">
                        <button style={{ cursor: "pointer" }} onClick={() => setIsBouncePopup(false)}>
                            Close
                        </button>
                    </DialogActions>
                </Dialog>
                </div>
                <UserActivityTracker pagename="Backlinks - Backlinks Report" />

                <div style={{ margin: 'auto', width: 'calc(100% - 40px)' }}>
                    <div className="">
                        {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
                    </div>

                    <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "5px", marginBottom: "5px" }} >
                        <Box style={{ padding: "0px 20px 0px 20px" }} >
                            <Grid container style={{ display: "flex", alignItems: "center" }} >
                                <Grid item xs={12} md={6}>
                                    <div><p style={{ color: "#000" }}>All Rights Reserved Copyright © 2026 | <span style={{ color: "#ff601f" }}> Elite site Optimizer</span></p></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div style={{ display: "flex", gap: "30px", justifyContent: "end" }}>
                                        <p>
                                            {/* <span
                                          style={{ color: "#818181", cursor: "pointer" }}
                                          onClick={handleToggle}
                                        >
                                          FAQ's
                                        </span> */}
                                        </p></div>
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>

                    {!openCommonAlerts &&
                        <CommonErrorAlert
                            data={{
                                apiopen: apiopen,
                                apiErrorMsg: apierrorMsg,
                                isIconStyled: true
                            }}
                            closeAlert={apihandleClose} />
                    }

                </div>
            </div>
        </>
    );
}
